module.exports = __webpack_public_path__ + "title_icon2.c7b7ef8b.png";